import { createAction, props } from '@ngrx/store';

import { IError } from '@ruby/shared/models/request/error.interface';
import { IReservationDetails } from '@ruby/shared/models/reservations/reservations.interface';

export const loadReservations = createAction(
  '[Reservations] Load Reservations',
  props<{ data: { customerId: string; locations: Array<string>; status: string } }>()
);

export const loadReservationsSuccess = createAction(
  '[Reservations] Load Reservations Success',
  props<{ data: Array<IReservationDetails> }>()
);

export const loadReservationsFailure = createAction(
  '[Reservations] Load Reservations Failure',
  props<{ error: IError }>()
);
